module.exports = __webpack_public_path__ + "static/img/S1.9ea3c741.png";